import { makeStyles } from "@material-ui/core/styles";

const useStyleRicerca = makeStyles((theme) => ({
  pagina: {
    //minHeight: '100vh',
  },
  gridContainer: {
    backgroundColor: "#f5f5f5",
  },
  pannello: {
    padding: "10px",
    color: "#999999",
    height: "auto",
    overflow: "scroll",
  },
  anno: {
    textAlign: "left",
    fontSize: "3.5vw",
  },
  testoCard: {
    fontSize: "calc( 16px + (24 - 16) * (100vw - 360px) / (1920 - 360))",
    color: "#91A4AD",
    fontWeight: "600",
  },
  ulla: {
    paddingInlineStart: "0",
    marginTop: "0",
  },
  topic: {
    display: "inline",
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: '#ccc',
      color: theme.background.default,
    }
  },
  testoTopic: {
    fontSize: "calc( 16px + (24 - 16) * (100vw - 360px) / (1920 - 360))",
    color: "#91A4AD",
  },
  abstract: {
    marginTop: "3rem",
    marginBottom: "3rem",
    fontSize: "calc( 16px + (36 - 24) * (100vw - 360px) / (1920 - 360))",
    color: theme.palette.secondary.main,
  },
  absEng: {
    fontStyle: "italic",
  },
}));

export default useStyleRicerca;
